import dayjs from 'dayjs';
import { observer } from 'mobx-react-lite';
import ChangeValue from '../common/ChangeValue';

interface StrategyReturnHeroProps {
    totalReturn: number;
    dailyReturn: number;
    monthlyReturn: number;
    yearlyReturn: number;
    daysSinceStart?: number; // optional: 없으면 "총 수익률"만 표시
}

const StrategyReturnHero = observer(
    ({
        totalReturn,
        dailyReturn,
        monthlyReturn,
        yearlyReturn,
        // TODO 수익률이 아직 적용 전이면, '수익률 준비중' 표시 필요
        daysSinceStart,
    }: StrategyReturnHeroProps) => {
        return (
            <div className="flex flex-col items-center justify-center">
                <div className="text-base-content/60 mb-1 text-sm">
                    {daysSinceStart ? `${daysSinceStart}일간 총 수익률` : '총 수익률'}
                </div>
                <div className="text-5xl leading-none font-bold tabular-nums">
                    <ChangeValue value={totalReturn * 100} suffix="%" sign={true} round={1} />
                </div>

                {/* 기간별 수익률 */}
                <div className="mt-5 grid grid-cols-3 gap-4 text-center">
                    <div className="bg-base-200/60 rounded-lg px-5 py-3">
                        <div className="text-base-content/60 mb-1 text-sm">어제</div>
                        <div className="text-base font-semibold tabular-nums">
                            <ChangeValue
                                value={dailyReturn * 100}
                                suffix="%"
                                sign={true}
                                round={1}
                            />
                        </div>
                    </div>
                    <div className="bg-base-200/60 rounded-lg px-5 py-3">
                        <div className="text-base-content/60 mb-1 text-sm">
                            {dayjs().format('M월')}
                        </div>
                        <div className="text-base font-semibold tabular-nums">
                            <ChangeValue
                                value={monthlyReturn * 100}
                                suffix="%"
                                sign={true}
                                round={1}
                            />
                        </div>
                    </div>
                    <div className="bg-base-200/60 rounded-lg px-5 py-3">
                        <div className="text-base-content/60 mb-1 text-sm">
                            {dayjs().format('YYYY년')}
                        </div>
                        <div className="text-base font-semibold tabular-nums">
                            <ChangeValue
                                value={yearlyReturn * 100}
                                suffix="%"
                                sign={true}
                                round={1}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    },
);

export default StrategyReturnHero;
